import React from "react";
import { motion } from "framer-motion"; // Import Framer Motion

import AboutLand from "../components/componentsabout/AboutLand";
import AboutTagline from "../components/componentsabout/AboutTagline";
import Gastronomy from "../components/componentsabout/Gastronomy";
import Cultural from "../components/componentsabout/Cultural";
import Sea from "../components/componentsabout/Sea";
import Beach from "../components/componentsabout/Beach";
import Hiking from "../components/componentsabout/Hiking";
import Golf from "../components/componentsabout/Golf";
import Plane from "../components/componentsabout/Plane";
import FeaturedProperties from "../components/FeaturedProperties";
import "./About.css";

function About() {
  // Animation Variants
  const fadeInUp = {
    hidden: { opacity: 1, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };

  return (
    <div className="About">
      <AboutLand />
      <AboutTagline />

      {/* Animated Blocks */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <Gastronomy />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <Cultural />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <Sea />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <Beach />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <Hiking />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <Golf />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <Plane />
      </motion.div>

      <FeaturedProperties />
    </div>
  );
}

export default About;
